<template>
  <figure :class="classes" class="asd20-thumbnail-avatar">
    <img :src="thumbnail" :alt="label" />
  </figure>
</template>

<script>
export default {
  name: 'Asd20ThumbnailAvatar',
  props: {
    square: { type: Boolean, default: false },
    contain: { type: Boolean, default: false },
    label: { type: String, default: 'The logo for this link.' },
    thumbnail: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return {
        'asd20-thumbnail-avatar--square': this.square,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-thumbnail-avatar {
  width: space(2);
  height: space(2);
  overflow: hidden;
  background: rgba(0, 0, 0, 0.125);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0;

  img {
    display: block;
    object-fit: cover;
    object-position: center;
    height: 100%;
    width: 100%;
  }
  &--square {
    display: block;
    border-radius: 0;
  }
  &--contain {
    img {
      object-fit: contain;
    }
  }
}

@media screen and (min-width: 1024px) {
  .asd20-thumbnail-avatar {
    &--square {
      // width: space(12);
      // height: space(8);
    }
  }
}
</style>
